import { z } from 'zod';

// Common Schema for BIGDES Definitions (Simple lookups)
export const BigdesDefinitionSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, 'form.validation.nameRequired'),
    code: z.string().optional(),
    description: z.string().optional(),
    isActive: z.boolean().default(true),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreateBigdesDefinitionSchema = BigdesDefinitionSchema.omit({ id: true });
export const UpdateBigdesDefinitionSchema = BigdesDefinitionSchema;